/*
  AYO Build your box (sections/ayo-box.liquid).
  Every + adds the piece to the real cart. The box is what is in the cart from this page's collections,
  so the count and the discount are always the same as what checkout will see.
*/
(function () {
  if (customElements.get('ayo-box')) return;
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const fill = (t, o) => String(t || '').replace(/\[(\w+)\]/g, (m, k) => (k in o ? o[k] : m));
  const moneyFmt = (cents, format) => {
    const f = (n, dec, th, ds) => { const [i, d] = (n / 100).toFixed(dec).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (d ? ds + d : ''); };
    return String(format || 'LE {{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_no_decimals') return f(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return f(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return f(cents, 0, '.', ',');
      return f(cents, 2, ',', '.');
    }).replace(/[.,]00(?=\D*$)/, '');
  };
  const sized = (u, w) => (u ? `${u}${u.indexOf('?') > -1 ? '&' : '?'}width=${w}` : '');
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = () => ((window.routes && window.routes.cart_url) || '/cart').replace(/\/cart$/, '');

  class AyoBox extends HTMLElement {
    connectedCallback() {
      const raw = this.querySelector('[data-ayo-box-data]');
      if (!raw) return;
      try { this.d = JSON.parse(raw.textContent); } catch (e) { return; }
      this.t = this.d.text;
      this.tiers = (this.d.tiers || []).sort((a, b) => a[0] - b[0]);
      this.M = (c) => moneyFmt(c, this.d.money);
      this.byId = {};
      this.groupOf = {};
      this.d.groups.forEach((g) => g.products.forEach((p) => { this.byId[p.id] = p; this.groupOf[p.id] = g.key; }));
      this.lines = [];
      this.rows();
      this.addEventListener('click', (e) => this.onClick(e));
      this.querySelectorAll('dialog').forEach((dlg) => {
        dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
        dlg.addEventListener('close', () => document.documentElement.classList.remove('ayo-lock'));
      });
      document.body.classList.add('has-ayo-box-bar');
      this.onCart = () => this.load();
      document.addEventListener('ayo:cart-changed', this.onCart);
      this.paint();
      this.load();
      this.spy();
    }

    disconnectedCallback() {
      document.body.classList.remove('has-ayo-box-bar');
      document.removeEventListener('ayo:cart-changed', this.onCart);
      if (this.io) this.io.disconnect();
    }

    $(sel) { return this.querySelector(sel); }

    rows() {
      this.d.groups.forEach((g) => {
        const row = this.$(`[data-ayo-box-row="${g.key}"]`);
        if (!row) return;
        row.innerHTML = g.products.map((p) => `<div class="ayo-box__card ayo-box__glass">
          <div class="ayo-box__pic"><a href="${esc(p.u)}" tabindex="-1" aria-hidden="true">${p.i ? `<img src="${esc(p.i)}" alt="${esc(p.t)}" loading="lazy" width="500" height="500">` : ''}</a>
            <span class="ayo-box__cnt" data-ayo-box-cnt="${p.id}" hidden></span>
            <button type="button" class="ayo-box__add" data-ayo-box-add="${p.id}" aria-label="+ ${esc(p.t)}">+</button></div>
          <a class="ayo-box__name" href="${esc(p.u)}">${esc(p.t)}</a>
          <span class="ayo-box__price">${esc(this.M(p.n))}${this.d.compare !== false && p.c > p.n ? ` <s>${esc(this.M(p.c))}</s>` : ''}</span>
        </div>`).join('');
      });
    }

    // Box = cart lines whose product is on this page.
    get box() { return this.lines.filter((l) => this.byId[l.product_id]); }
    count() { return this.box.reduce((a, l) => a + l.quantity, 0); }
    sum() { return this.box.reduce((a, l) => a + l.original_line_price, 0); }
    off(n, sum) { let d = 0; this.tiers.forEach(([q, v]) => { if (n >= q) d = v; }); return Math.min(d, sum); }

    async load() {
      try {
        const res = await fetch(`${root()}/cart.js`, { headers: { Accept: 'application/json' } });
        if (!res.ok) return;
        const cart = await res.json();
        const waiting = this.lines.filter((l) => l.tmp && !l.sent);
        this.lines = (cart.items || []).concat(waiting);
        this.paint();
      } catch (e) { /* offline: keep what we have */ }
    }

    paint(before) {
      const n = this.count();
      const sum = this.sum();
      const d = this.off(n, sum);
      const next = this.tiers.find(([q]) => q > n);
      this.querySelectorAll('[data-ayo-box-rung]').forEach((r) => {
        const q = parseInt(r.dataset.ayoBoxRung, 10);
        r.classList.toggle('is-on', n >= q);
        r.classList.toggle('is-next', !!next && next[0] === q);
      });
      const msg = this.$('[data-ayo-box-msg]');
      if (msg) msg.innerHTML = next ? fill(esc(this.t.next), { left: `<b>${next[0] - n}</b>`, amount: `<b>${esc(this.M(next[1]))}</b>` }) : esc(this.t.top);
      const save = this.$('[data-ayo-box-save]'); if (save) save.textContent = d ? `−${this.M(d)}` : '';
      const last = this.tiers.length ? this.tiers[this.tiers.length - 1][0] : 1;
      const fillEl = this.$('[data-ayo-box-fill]'); if (fillEl) fillEl.style.width = `${Math.min(100, (n / last) * 100)}%`;
      // per product and per group counts
      const per = {}; const perG = {};
      this.box.forEach((l) => { per[l.product_id] = (per[l.product_id] || 0) + l.quantity; const g = this.groupOf[l.product_id]; perG[g] = (perG[g] || 0) + l.quantity; });
      this.querySelectorAll('[data-ayo-box-cnt]').forEach((el) => { const c = per[el.dataset.ayoBoxCnt] || 0; el.hidden = !c; el.textContent = c ? `×${c}` : ''; });
      this.querySelectorAll('[data-ayo-box-tabcount]').forEach((el) => { const c = perG[el.dataset.ayoBoxTabcount] || 0; el.hidden = !c; el.textContent = c ? String(c) : ''; });
      // bar
      const total = this.$('[data-ayo-box-total]'); if (total) total.textContent = this.M(sum - d);
      const was = this.$('[data-ayo-box-was]'); if (was) was.textContent = d ? this.M(sum) : '';
      const note = this.$('[data-ayo-box-note]');
      if (note) { note.textContent = n ? fill(this.t.note, { count: n, saved: this.M(d) }) : this.t.first; note.classList.toggle('is-ok', d > 0); }
      const pile = this.$('[data-ayo-box-pile]');
      if (pile) pile.innerHTML = this.box.slice(-3).map((l) => (l.image ? `<img src="${esc(sized(l.image, 100))}" alt="" width="34" height="34">` : '')).join('');
      const open = this.$('[data-ayo-box-open]'); if (open) open.disabled = !n;
      if (before !== undefined && d > before) {
        this.toast(fill(this.t.unlocked, { amount: this.M(d) }));
        ['[data-ayo-box-total]', '[data-ayo-box-save]'].forEach((sel) => { const el = this.$(sel); if (el) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); } });
      }
      const sheet = this.$('[data-ayo-box-sheet]');
      if (sheet && sheet.open) this.list();
    }

    list() {
      const n = this.count(), sum = this.sum(), d = this.off(n, sum);
      this.$('[data-ayo-box-list]').innerHTML = this.box.map((l) => `<div class="ayo-box__line">
        ${l.image ? `<img src="${esc(sized(l.image, 120))}" alt="" width="48" height="48">` : '<span></span>'}
        <div class="ayo-box__lt">${esc(l.product_title)}${l.variant_title ? `<br><small>${esc(l.variant_title)}</small>` : ''}${l.quantity > 1 ? ` <small>×${l.quantity}</small>` : ''}</div>
        <b>${esc(this.M(l.original_line_price))}</b>
        ${l.tmp ? '<span class="ayo-box__wait" aria-hidden="true"></span>' : `<button type="button" data-ayo-box-rm="${esc(l.key)}" data-q="${l.quantity}" aria-label="Remove">×</button>`}
      </div>`).join('');
      this.$('[data-ayo-box-tcount]').textContent = fill(n === 1 ? this.t.one : this.t.many, { count: n });
      this.$('[data-ayo-box-tsum]').textContent = this.M(sum);
      this.$('[data-ayo-box-toff]').textContent = `−${this.M(d)}`;
      this.$('[data-ayo-box-tpay]').textContent = this.M(sum - d);
    }

    toast(text, bad) {
      const el = this.$('[data-ayo-box-toast]'); if (!el) return;
      el.textContent = text; el.classList.toggle('is-bad', !!bad); el.hidden = false;
      el.classList.remove('is-in'); void el.offsetWidth; el.classList.add('is-in');
      clearTimeout(this.toastT); this.toastT = setTimeout(() => { el.hidden = true; }, 2200);
    }

    show(dlg) { if (dlg && typeof dlg.showModal === 'function') { dlg.showModal(); document.documentElement.classList.add('ayo-lock'); } }

    onClick(e) {
      const add = e.target.closest('[data-ayo-box-add]');
      if (add) {
        const p = this.byId[add.dataset.ayoBoxAdd];
        if (!p) return;
        if (!p.z.length) { this.add(p.v, add); return; }
        this.cur = p;
        const sh = this.$('[data-ayo-box-size]');
        sh.querySelector('[data-ayo-box-simg]').src = p.i || '';
        sh.querySelector('[data-ayo-box-stitle]').textContent = p.t;
        sh.querySelector('[data-ayo-box-sizes]').innerHTML = p.z.map(([z, id]) => `<button type="button" class="ayo-box__size" data-ayo-box-variant="${id}">${esc(z)}</button>`).join('');
        this.show(sh);
        return;
      }
      const v = e.target.closest('[data-ayo-box-variant]');
      if (v) { this.$('[data-ayo-box-size]').close(); this.add(parseInt(v.dataset.ayoBoxVariant, 10), this.$(`[data-ayo-box-add="${this.cur.id}"]`)); return; }
      const rm = e.target.closest('[data-ayo-box-rm]');
      if (rm) { this.change(rm.dataset.ayoBoxRm, parseInt(rm.dataset.q, 10) - 1); return; }
      if (e.target.closest('[data-ayo-box-close]')) { const dlg = e.target.closest('dialog'); if (dlg) dlg.close(); return; }
      if (e.target.closest('[data-ayo-box-open]')) { this.list(); this.show(this.$('[data-ayo-box-sheet]')); return; }
      const tab = e.target.closest('[data-ayo-box-tab]');
      if (tab) { this.go(tab.dataset.ayoBoxTab); return; }
      if (e.target.closest('[data-ayo-box-start]')) { const g = this.d.groups[0]; if (g) this.go(g.key); }
    }

    go(key) {
      const sec = this.$(`[data-ayo-box-sec="${key}"]`);
      if (sec) sec.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'start' });
      this.active(key);
    }

    active(key) {
      this.querySelectorAll('[data-ayo-box-tab]').forEach((t) => {
        const on = t.dataset.ayoBoxTab === key; t.classList.toggle('is-on', on);
        if (on) { const bar = t.parentNode; const l = t.offsetLeft - bar.offsetLeft; if (l < bar.scrollLeft || l + t.offsetWidth > bar.scrollLeft + bar.clientWidth) bar.scrollTo({ left: Math.max(0, l - 12), behavior: reduce() ? 'auto' : 'smooth' }); }
      });
    }

    spy() {
      const secs = this.querySelectorAll('[data-ayo-box-sec]');
      if (!secs.length) return;
      this.active(secs[0].dataset.ayoBoxSec);
      if (!('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver((en) => { en.forEach((x) => { if (x.isIntersecting) this.active(x.target.dataset.ayoBoxSec); }); }, { rootMargin: '-45% 0px -50% 0px' });
      secs.forEach((s) => this.io.observe(s));
    }

    sectionsBody(body) {
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart && typeof cart.getSectionsToRender === 'function') { body.sections = cart.getSectionsToRender().map((x) => x.id); body.sections_url = window.location.pathname; }
      return cart;
    }

    refreshDrawer(cart, data) {
      if (!cart || !data.sections || typeof cart.getSectionsToRender !== 'function') return;
      cart.classList.toggle('is-empty', data.item_count === 0);
      cart.getSectionsToRender().forEach((sec) => {
        const html = data.sections[sec.id]; if (!html) return;
        const el = sec.selector ? document.querySelector(sec.selector) : document.getElementById(sec.id); if (!el) return;
        const src = new DOMParser().parseFromString(html, 'text/html').querySelector(sec.selector || '.shopify-section');
        if (src) el.innerHTML = src.innerHTML;
      });
    }

    // Shows the piece in the box at once, then sends it to the cart in the background (one request at a time).
    add(variantId, btn) {
      const p = this.byId[(btn && btn.dataset.ayoBoxAdd) || ''] || Object.values(this.byId).find((x) => x.v === variantId || x.z.some((z) => z[1] === variantId));
      const before = this.off(this.count(), this.sum());
      const z = p && p.z.find((x) => x[1] === variantId);
      const tmp = { key: `tmp-${Date.now()}-${Math.random()}`, tmp: true, product_id: p ? p.id : 0, product_title: p ? p.t : '', variant_title: z ? z[0] : '', quantity: 1, original_line_price: z ? z[2] : (p ? p.n : 0), image: p ? p.i : '' };
      this.lines = this.lines.concat(tmp);
      if (this.off(this.count(), this.sum()) > before) this.paint(before); else { this.paint(); this.toast(this.t.added); }
      if (btn) { btn.classList.remove('is-pop'); void btn.offsetWidth; btn.classList.add('is-pop'); }
      this.queue = (this.queue || Promise.resolve()).then(() => this.send(variantId, tmp));
      return this.queue;
    }

    async send(variantId, tmp) {
      const body = { items: [{ id: variantId, quantity: 1, properties: { _bundle: 'Build your box' } }] };
      const cart = this.sectionsBody(body);
      try {
        const res = await fetch(`${root()}/cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || '');
        tmp.sent = true;
        if (cart) { cart.classList.remove('is-empty'); this.refreshDrawer(cart, data); }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ayo-box', productVariantId: variantId, cartData: data });
        document.removeEventListener('ayo:cart-changed', this.onCart);
        document.dispatchEvent(new CustomEvent('ayo:cart-changed'));
        document.addEventListener('ayo:cart-changed', this.onCart);
      } catch (err) {
        this.lines = this.lines.filter((l) => l !== tmp);
        this.paint();
        this.toast(err.message || this.t.error, true);
        return;
      }
      // read the real cart once the last waiting piece is in
      clearTimeout(this.syncT);
      this.syncT = setTimeout(() => this.load(), 250);
    }

    async change(key, quantity) {
      const body = { id: key, quantity: Math.max(0, quantity) };
      const cart = this.sectionsBody(body);
      try {
        const res = await fetch(`${root()}/cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || '');
        this.lines = data.items || [];
        this.refreshDrawer(cart, data);
        this.paint();
        if (!this.count()) { const s = this.$('[data-ayo-box-sheet]'); if (s.open) s.close(); }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ayo-box', cartData: data });
        document.removeEventListener('ayo:cart-changed', this.onCart);
        document.dispatchEvent(new CustomEvent('ayo:cart-changed'));
        document.addEventListener('ayo:cart-changed', this.onCart);
      } catch (err) {
        this.toast(err.message || this.t.error, true);
      }
    }
  }
  customElements.define('ayo-box', AyoBox);
})();
